import { render } from "./widthSelectBox.vue?vue&type=template&id=2b90b78f&scoped=true"
import script from "./widthSelectBox.vue?vue&type=script&lang=js"
export * from "./widthSelectBox.vue?vue&type=script&lang=js"

import "./widthSelectBox.vue?vue&type=style&index=0&id=2b90b78f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b90b78f"]])

export default __exports__